import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
// eslint-disable-next-line @repo/internal/react/no-class-components
export var AnnotationViewWrapper = /*#__PURE__*/function (_React$PureComponent) {
  function AnnotationViewWrapper() {
    _classCallCheck(this, AnnotationViewWrapper);
    return _callSuper(this, AnnotationViewWrapper, arguments);
  }
  _inherits(AnnotationViewWrapper, _React$PureComponent);
  return _createClass(AnnotationViewWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onViewed = this.props.onViewed;
      if (onViewed) {
        onViewed();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(React.PureComponent);